<template>
  <el-dialog :title="title" append-to-body fullscreen modal="false" :visible.sync="visible" :before-close="handleClose">
    <div v-if="jobList">
      <avue-crud :data="queryList" :option="option" :page.sync="page" @on-load="onLoad" :search.sync="query"
        @search-change="searchChange" @row-save="rowSave" @row-del="rowDel">
        <template v-slot:userNameForm="{ row }">
          <UserSelect @onChecked="handleUserCheck" />
        </template>
      </avue-crud>
    </div>
    <div v-else>
      <el-alert title="请设置机构类型" center :closable="false" type="error" />
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
import api from './api'
import UserSelect from '@/framework/components/user/select'
export default {
  components: {
    UserSelect
  },
  props: {
    visible: {
      type: Boolean, // sync
      default: false
    },
    title: {
      type: String,
      default: '设置职位'
    },
    row: {
      type: Object
    }
  },
  data() {
    return {
      count: 0,
      jobList: null,
      queryList: null,
      query: {
        orgSubjectId: ''
      },
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      option: {
        title: '职位列表',
        align: 'center',
        menuAlign: 'center',
        editBtn: false,
        column: [
          {
            label: '职位',
            prop: 'roleName', // label: subjectName, roleSubjectId(value): id
            type: 'select',
            dicData: [],
            search: true
          },
          {
            label: '用户',
            prop: 'userName',
            formslot: true,
            search: true
          }
        ]
      },
      userSubjectIdList: []
    }
  },
  computed: {
    jobRow() {
      return this.row
    },
    queryWatch() {
      return {
        count: this.count,
        ...this.query,
        orgSubjectId: this.query.orgSubjectId,
        currentPage: this.page.currentPage,
        pageSize: this.page.pageSize
      }
    }
  },
  watch: {
    jobRow(row) {
      const {
        orgType,
        permissionSubjectId
      } = row
      if (orgType) {
        this.loadJobList(orgType) // init job list
        this.query.orgSubjectId = permissionSubjectId
      } else {
        this.jobList = null
      }
    },
    queryWatch(val, oldval) {
      if (!(_.isEqual(val, oldval))) {
        const {
          orgSubjectId,
          roleSubjectId,
          userName
        } = this.query
        let params = null
        if (userName) {
          params = {
            userName
          }
        }
        this.loadORUList({
          orgSubjectId,
          roleSubjectId
        }, params)
      }
    }
  },
  methods: {
    onLoad(page) {
      this.page = page
    },
    handleClose(done) {
      this.$emit('update:visible', false)
    },
    async loadJobList(orgType) {
      try {
        const { data } = await api.apiJobListByorgType(orgType)
        this.jobList = data
        const roleNameDicData = []
        if (data.length) {
          data.map(item => {
            const {
              subjectName,
              id
            } = item
            roleNameDicData.push({
              label: subjectName,
              value: id
            })
          })
          this.option.column[0].dicData = roleNameDicData
        }
      } catch ({ msg }) {
        this.$message.error(msg)
      }
    },
    async loadORUList(postdata, params) {
      try {
        const { data } = await api.apiJobQueryByorgSubjectId(postdata, null, {
          pageNum: this.page.currentPage,
          pageSize: this.page.pageSize,
          ...params
        })
        const {
          records,
          total
        } = data
        this.queryList = records
        this.page.total = total
      } catch ({ msg }) {
        this.$message.error(msg)
      }
    },
    async rowSave(row, loading, done) {
      const {
        permissionSubjectId
      } = this.jobRow
      const params = {
        orgSubjectId: permissionSubjectId,
        roleSubjectIdList: row.roleName,
        userSubjectIdList: this.userSubjectIdList
      }
      try {
        await api.apiJobORUAdd(params)
        this.count += 1
        loading() && done()
      } catch ({ msg }) {
        this.$message.error(msg) && done()
      }
    },
    async rowDel(row) {
      try {
        const res = await this.$confirm('确定将选择数据删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        if (res === 'confirm') {
          const {
            id
          } = row
          await api.apiJobORUDelete(id)
          this.count += 1
        }
      } catch ({ msg }) {
        this.$message.error(msg)
      }
    },
    searchChange(params, done) {
      done()
      const {
        roleName,
        userName
      } = params
      this.query = {
        ...this.query,
        roleSubjectId: roleName,
        userName
      }
    },
    handleUserCheck(users) {
      if (users.length) {
        let subjectIds = []
        users.map(item => {
          subjectIds.push(item.permissionSubjectId)
        })
        this.userSubjectIdList = subjectIds
      }
    }
  }
}
</script>

<style lang='scss' scoped>
:deep(.el-dialog__body) {
  border-top: 1px solid #ebeef5;
}
</style>
